import { defineElement } from '@amzn/exs-elements/web-component';
import { accountLinkingCard } from './definition';

defineElement(accountLinkingCard);
